import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_2 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-4xl sm:w-full" }
const _hoisted_3 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6" }
const _hoisted_4 = { class: "text-lg leading-6 font-medium text-white" }
const _hoisted_5 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto max-h-[calc(100vh-12rem)]" }
const _hoisted_6 = { class: "space-y-6" }
const _hoisted_7 = {
  key: 0,
  class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4"
}
const _hoisted_8 = { class: "flex items-start gap-3" }
const _hoisted_9 = { class: "text-sm font-medium text-red-800 dark:text-red-200" }
const _hoisted_10 = { class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5" }
const _hoisted_12 = { class: "md:col-span-2" }
const _hoisted_13 = { class: "md:col-span-2" }
const _hoisted_14 = { class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600" }
const _hoisted_15 = { class: "space-y-5" }
const _hoisted_16 = {
  key: 0,
  class: "absolute z-20 mt-1 w-full rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg max-h-48 overflow-y-auto overscroll-contain"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_19 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 italic"
}
const _hoisted_20 = {
  key: 1,
  class: "px-3 py-2 text-sm text-gray-400 italic"
}
const _hoisted_21 = {
  key: 0,
  class: "flex items-center gap-2 mt-2 text-sm text-slate-400"
}
const _hoisted_22 = {
  key: 1,
  class: "flex flex-wrap gap-1.5 mt-2"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 2,
  class: "mt-1 text-xs text-gray-400 italic"
}
const _hoisted_25 = {
  key: 0,
  class: "absolute z-20 mt-1 w-full rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg max-h-48 overflow-y-auto overscroll-contain"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_28 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-400 italic"
}
const _hoisted_29 = {
  key: 1,
  class: "px-3 py-2 text-sm text-gray-400 italic"
}
const _hoisted_30 = {
  key: 2,
  class: "px-3 py-2 text-xs text-gray-400 border-t border-gray-100 dark:border-gray-600"
}
const _hoisted_31 = {
  key: 0,
  class: "flex items-center gap-2 mt-2 text-sm text-slate-400"
}
const _hoisted_32 = {
  key: 1,
  class: "flex flex-wrap gap-1.5 mt-2"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 2,
  class: "mt-1 text-xs text-gray-400 italic"
}
const _hoisted_35 = {
  key: 1,
  class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600"
}
const _hoisted_36 = { class: "label" }
const _hoisted_37 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_38 = { class: "flex items-center gap-4 w-full" }
const _hoisted_39 = { class: "h-11 w-11 rounded-xl flex items-center justify-center bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200" }
const _hoisted_40 = { class: "min-w-0 flex-1 overflow-hidden" }
const _hoisted_41 = ["title"]
const _hoisted_42 = {
  key: 2,
  class: "bg-gray-50 dark:bg-gray-700/30 p-5 rounded-xl border border-gray-200 dark:border-gray-600"
}
const _hoisted_43 = { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = {
  key: 0,
  class: "error-message"
}
const _hoisted_46 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = ["disabled"]

import { ref, reactive, watch, computed, onMounted, onUnmounted } from 'vue'
import UploadIcon from '@/components/icons/UploadIcon.vue'
import { positionService, type Position } from '@/services/positionService'
import { employeeService, type Employee } from '@/services/employeeService'
import { Loader2, X } from 'lucide-vue-next'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000

const MAX_EMPLOYEE_RESULTS = 50
const INITIAL_EMPLOYEE_PREVIEW = 10

interface MaterialForm {
  title: string
  description: string
  type: 'Online form' | 'URL Link' | 'Doc File'
  source: File | string | null
  url_link: string
  status: 'active' | 'inactive'
  position_viewers: number[]
  user_viewers: number[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MaterialFormModal',
  props: {
    isOpen: { type: Boolean },
    mode: {},
    form: {},
    error: {},
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: __emit }) {

const toast = useToast()
const props = __props

const emit = __emit

const localForm = reactive({
  title: '',
  description: '',
  type: 'Doc File' as MaterialForm['type'],
  source: null as File | string | null,
  url_link: '',
  status: 'active' as MaterialForm['status'],
})

const fileInput = ref<HTMLInputElement | null>(null)
const isDragOver = ref(false)
const linkError = ref<string>('')
const localError = ref<string>('')
const positions = ref<Position[]>([])
const employees = ref<Employee[]>([])
const fetching = ref(false)

const selectedPositionIds = ref<number[]>([])
const selectedEmployeeIds = ref<number[]>([])
const positionSearch = ref('')
const employeeSearch = ref('')
const positionOpen = ref(false)
const employeeOpen = ref(false)
const positionContainer = ref<HTMLElement | null>(null)
const employeeContainer = ref<HTMLElement | null>(null)

const filteredPositions = computed(() => {
  if (!positionSearch.value) return positions.value
  const q = positionSearch.value.toLowerCase()
  return positions.value.filter(p => p.name.toLowerCase().includes(q))
})

const getEmployeeDisplayName = (e: Employee) => {
  const name = e.first_name ? `${e.first_name} ${e.last_name}` : (e.username || '')
  return e.position ? `${name} (${e.position})` : name
}

const sortedEmployees = computed(() =>
  [...employees.value].sort((a, b) =>
    getEmployeeDisplayName(a).localeCompare(getEmployeeDisplayName(b))
  )
)

const filteredEmployees = computed(() => {
  const q = employeeSearch.value.trim().toLowerCase()
  const selectedSet = new Set(selectedEmployeeIds.value)

  let pool = sortedEmployees.value
  if (q) {
    pool = pool.filter(e => getEmployeeDisplayName(e).toLowerCase().includes(q))
  }

  const selectedItems = pool.filter(e => selectedSet.has(e.id))
  const unselectedItems = pool.filter(e => !selectedSet.has(e.id))

  if (!q) {
    return [...selectedItems, ...unselectedItems.slice(0, INITIAL_EMPLOYEE_PREVIEW)]
  }

  const remaining = Math.max(0, MAX_EMPLOYEE_RESULTS - selectedItems.length)
  return [...selectedItems, ...unselectedItems.slice(0, remaining)]
})

const employeeListHint = computed(() => {
  if (!employees.value.length) return ''
  const q = employeeSearch.value.trim()
  const total = employees.value.length

  if (!q && total > INITIAL_EMPLOYEE_PREVIEW) {
    return `Showing first ${INITIAL_EMPLOYEE_PREVIEW} of ${total} — type to search all employees`
  }
  if (q && filteredEmployees.value.length >= MAX_EMPLOYEE_RESULTS) {
    return 'Too many matches — refine your search'
  }
  return ''
})

const displayError = computed(() => props.error || localError.value)

const getPositionName = (id: number) => positions.value.find(p => p.id === id)?.name || 'Unknown'

const getEmployeeName = (id: number) => {
  const emp = employees.value.find(e => e.id === id)
  if (!emp) return 'Unknown'
  return getEmployeeDisplayName(emp) || 'Unknown'
}

const removePosition = (id: number) => {
  selectedPositionIds.value = selectedPositionIds.value.filter(v => v !== id)
}

const removeEmployee = (id: number) => {
  selectedEmployeeIds.value = selectedEmployeeIds.value.filter(v => v !== id)
}

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (positionContainer.value && !positionContainer.value.contains(target)) {
    positionOpen.value = false
  }
  if (employeeContainer.value && !employeeContainer.value.contains(target)) {
    employeeOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('mousedown', handleClickOutside)
})

let dependenciesFetched = false

const fetchDependencies = async () => {
  if (dependenciesFetched) return
  fetching.value = true
  try {
    const [posRes, empRes] = await Promise.all([
      positionService.getPositions(),
      employeeService.getEmployees({ per_page: 1000 })
    ])
    positions.value = posRes
    employees.value = empRes.data || []
    dependenciesFetched = true
  } catch (err) {
    console.error('Failed to fetch dependencies:', err)
  } finally {
    fetching.value = false
  }
}

const syncFormFromProps = (newForm: MaterialForm) => {
  localForm.title = newForm.title
  localForm.description = newForm.description || ''
  localForm.type = newForm.type || 'Doc File'
  localForm.source = newForm.source
  localForm.url_link = newForm.url_link || ''
  localForm.status = newForm.status || 'active'
  selectedPositionIds.value = newForm.position_viewers ? [...newForm.position_viewers] : []
  selectedEmployeeIds.value = newForm.user_viewers ? [...newForm.user_viewers] : []
}

watch(() => props.form, syncFormFromProps, { immediate: true })

watch(() => props.isOpen, (open) => {
  if (open) {
    fetchDependencies()
    syncFormFromProps(props.form)
    localError.value = ''
    positionSearch.value = ''
    employeeSearch.value = ''
    positionOpen.value = false
    employeeOpen.value = false
  } else {
    isDragOver.value = false
    if (fileInput.value) fileInput.value.value = ''
    linkError.value = ''
    localError.value = ''
    positionSearch.value = ''
    employeeSearch.value = ''
    positionOpen.value = false
    employeeOpen.value = false
  }
})

watch(() => localForm.type, (newType, oldType) => {
  if (newType !== oldType) {
    linkError.value = ''
    localError.value = ''
  }
})

const openFilePicker = () => fileInput.value?.click()
const onDragEnter = () => (isDragOver.value = true)
const onDragOver = () => (isDragOver.value = true)
const onDragLeave = () => (isDragOver.value = false)

const onDrop = (e: DragEvent) => {
  isDragOver.value = false
  const file = e.dataTransfer?.files?.[0] ?? null
  if (!file) return

  const MAX_FILE_SIZE = 25 * 1024 * 1024
  if (file.size > MAX_FILE_SIZE) {
    localError.value = 'Error: The file size exceeds 25MB.'
    toast.error(localError.value, { timeout: toastTimeout })
    return
  }

  localForm.source = file
  if (fileInput.value) fileInput.value.value = ''
}

const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0] ?? null

  const MAX_FILE_SIZE = 25 * 1024 * 1024
  if (file && file.size > MAX_FILE_SIZE) {
    localError.value = 'Error: The file size exceeds 25MB.'
    toast.error(localError.value, { timeout: toastTimeout })
    if (fileInput.value) fileInput.value.value = ''
    return
  }

  localError.value = ''
  localForm.source = file
}

const selectedFileName = computed(() => {
  const src = localForm.source
  if (src instanceof File) return src.name
  if (typeof src === 'string' && src.length) return src.split('/').pop() || ''
  return ''
})

const validateForm = (): boolean => {
  localError.value = ''
  linkError.value = ''

  if (!localForm.title) {
    localError.value = 'Title is required.'
    toast.error(localError.value, { timeout: toastTimeout })
    return false
  }

  if (props.mode === 'add' && selectedPositionIds.value.length === 0 && selectedEmployeeIds.value.length === 0) {
    localError.value = 'Please select at least one viewer.'
    toast.error(localError.value, { timeout: toastTimeout })
    return false
  }

  if (localForm.type === 'URL Link' || localForm.type === 'Online form') {
    if (!localForm.url_link) {
      linkError.value = 'Please enter a URL.'
      toast.error(linkError.value, { timeout: toastTimeout })
      return false
    }
    if (!/^https?:\/\//i.test(localForm.url_link)) {
      linkError.value = 'Link must start with https:// or http://'
      toast.error(linkError.value, { timeout: toastTimeout })
      return false
    }
  } else {
    if (props.mode === 'add' && !localForm.source) {
      localError.value = 'Please select a file to upload.'
      toast.error(localError.value, { timeout: toastTimeout })
      return false
    }
  }

  return true
}

const handleSave = () => {
  if (!validateForm()) return
  emit('save', {
    ...localForm,
    position_viewers: [...selectedPositionIds.value],
    user_viewers: [...selectedEmployeeIds.value],
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 z-50 overflow-y-auto",
            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.mode === 'add' ? 'Add Material' : 'Edit Material'), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (displayError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("svg", {
                                class: "h-5 w-5 text-red-500",
                                viewBox: "0 0 20 20",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "fill-rule": "evenodd",
                                  d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                  "clip-rule": "evenodd"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_9, _toDisplayString(displayError.value), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Basic Information", -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label" }, [
                            _createTextVNode("File Name (Title) "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localForm.title) = $event)),
                            type: "text",
                            class: "input",
                            placeholder: "Enter title"
                          }, null, 512), [
                            [_vModelText, localForm.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label" }, "Description", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localForm.description) = $event)),
                            class: "input",
                            placeholder: "Enter description",
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, localForm.description]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "label" }, [
                            _createTextVNode("Type "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localForm.type) = $event)),
                            class: "input"
                          }, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("option", { value: "Online form" }, "Online form", -1),
                            _createElementVNode("option", { value: "URL Link" }, "URL Link", -1),
                            _createElementVNode("option", { value: "Doc File" }, "Doc File", -1)
                          ]))], 512), [
                            [_vModelSelect, localForm.type]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label" }, "Status", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localForm.status) = $event)),
                            class: "input"
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("option", { value: "active" }, "Active", -1),
                            _createElementVNode("option", { value: "inactive" }, "Inactive", -1)
                          ]))], 512), [
                            [_vModelSelect, localForm.status]
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "Viewers & Access", -1)),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "label" }, "Viewers (By Position)", -1)),
                          _createElementVNode("div", {
                            class: "relative",
                            ref_key: "positionContainer",
                            ref: positionContainer
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((positionSearch).value = $event)),
                              type: "text",
                              placeholder: "Search positions...",
                              onFocus: _cache[6] || (_cache[6] = ($event: any) => (positionOpen.value = true)),
                              class: "input text-sm"
                            }, null, 544), [
                              [_vModelText, positionSearch.value]
                            ]),
                            (positionOpen.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPositions.value, (pos) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: pos.id,
                                      class: "flex items-center gap-2 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer text-sm"
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        value: pos.id,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedPositionIds).value = $event)),
                                        class: "rounded border-gray-300 text-primary focus:ring-primary"
                                      }, null, 8, _hoisted_17), [
                                        [_vModelCheckbox, selectedPositionIds.value]
                                      ]),
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(pos.name), 1)
                                    ]))
                                  }), 128)),
                                  (!positions.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Loading positions..."))
                                    : (!filteredPositions.value.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, "No positions match"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 512),
                          (fetching.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createVNode(_unref(Loader2), { class: "w-4 h-4 animate-spin" }),
                                _cache[22] || (_cache[22] = _createTextVNode(" Loading... ", -1))
                              ]))
                            : (selectedPositionIds.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPositionIds.value, (id) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'psel-' + id,
                                      class: "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 dark:bg-primary-dark/10 text-primary dark:text-primary-dark"
                                    }, [
                                      _createTextVNode(_toDisplayString(getPositionName(id)) + " ", 1),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => (removePosition(id)),
                                        class: "hover:text-primary/70 dark:hover:text-primary-dark/70 leading-none"
                                      }, [
                                        _createVNode(_unref(X), { class: "w-3.5 h-3.5" })
                                      ], 8, _hoisted_23)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_24, "None selected"))
                        ]),
                        _createElementVNode("div", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label" }, "Viewers (By Specific Employee)", -1)),
                          _createElementVNode("div", {
                            class: "relative",
                            ref_key: "employeeContainer",
                            ref: employeeContainer
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((employeeSearch).value = $event)),
                              type: "text",
                              placeholder: "Search employees...",
                              onFocus: _cache[9] || (_cache[9] = ($event: any) => (employeeOpen.value = true)),
                              class: "input text-sm"
                            }, null, 544), [
                              [_vModelText, employeeSearch.value]
                            ]),
                            (employeeOpen.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployees.value, (employee) => {
                                    return (_openBlock(), _createElementBlock("label", {
                                      key: employee.id,
                                      class: "flex items-center gap-2 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer text-sm"
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        value: employee.id,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedEmployeeIds).value = $event)),
                                        class: "rounded border-gray-300 text-primary focus:ring-primary"
                                      }, null, 8, _hoisted_26), [
                                        [_vModelCheckbox, selectedEmployeeIds.value]
                                      ]),
                                      _createElementVNode("span", _hoisted_27, _toDisplayString(getEmployeeDisplayName(employee)), 1)
                                    ]))
                                  }), 128)),
                                  (!employees.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Loading employees..."))
                                    : (!filteredEmployees.value.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, "No employees found"))
                                      : (employeeListHint.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(employeeListHint.value), 1))
                                        : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 512),
                          (fetching.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_unref(Loader2), { class: "w-4 h-4 animate-spin" }),
                                _cache[24] || (_cache[24] = _createTextVNode(" Loading... ", -1))
                              ]))
                            : (selectedEmployeeIds.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedEmployeeIds.value, (id) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: 'esel-' + id,
                                      class: "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-primary/10 dark:bg-primary-dark/10 text-primary dark:text-primary-dark"
                                    }, [
                                      _createTextVNode(_toDisplayString(getEmployeeName(id)) + " ", 1),
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: ($event: any) => (removeEmployee(id)),
                                        class: "hover:text-primary/70 dark:hover:text-primary-dark/70 leading-none"
                                      }, [
                                        _createVNode(_unref(X), { class: "w-3.5 h-3.5" })
                                      ], 8, _hoisted_33)
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_34, "None selected"))
                        ])
                      ])
                    ]),
                    (localForm.type === 'Doc File')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "text-sm font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-200 dark:border-gray-600 pb-2" }, "File Upload", -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_36, [
                              _cache[27] || (_cache[27] = _createTextVNode("File ", -1)),
                              (__props.mode === 'add')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["rounded-2xl border-2 border-dashed p-6 cursor-pointer select-none bg-white/60 dark:bg-gray-800/50 border-gray-300/70 dark:border-gray-600/60 hover:bg-white/80 dark:hover:bg-gray-800/70", isDragOver.value ? 'ring-2 ring-primary/50 border-primary/60' : '']),
                              onClick: openFilePicker,
                              onDragenter: _withModifiers(onDragEnter, ["prevent"]),
                              onDragover: _withModifiers(onDragOver, ["prevent"]),
                              onDragleave: _withModifiers(onDragLeave, ["prevent"]),
                              onDrop: _withModifiers(onDrop, ["prevent"])
                            }, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createVNode(UploadIcon)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  (selectedFileName.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("p", {
                                          class: "text-sm font-semibold text-gray-800 dark:text-gray-100 truncate",
                                          title: selectedFileName.value
                                        }, _toDisplayString(selectedFileName.value), 9, _hoisted_41),
                                        _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " Click or drop to change file ", -1))
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-800 dark:text-gray-100" }, " Drag & drop your file here ", -1)),
                                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, " or click to browse ", -1))
                                      ], 64))
                                ])
                              ])
                            ], 34),
                            _createElementVNode("input", {
                              ref_key: "fileInput",
                              ref: fileInput,
                              type: "file",
                              class: "hidden",
                              accept: "*/*",
                              onChange: handleFileChange
                            }, null, 544)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (localForm.type === 'URL Link' || localForm.type === 'Online form')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("h4", _hoisted_43, _toDisplayString(localForm.type === 'URL Link' ? 'URL Link' : 'Online Form'), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_44, [
                              _createTextVNode(_toDisplayString(localForm.type === 'URL Link' ? 'URL Link' : 'Online Form URL') + " ", 1),
                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((localForm.url_link) = $event)),
                              type: "text",
                              class: _normalizeClass(["input", { 'border-danger dark:border-danger-dark': linkError.value }]),
                              placeholder: "https://..."
                            }, null, 2), [
                              [_vModelText, localForm.url_link]
                            ]),
                            (linkError.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(linkError.value), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "w-full sm:w-auto px-4 py-2 rounded-xl font-semibold text-sm bg-primary hover:bg-secondary text-white shadow-sm hover:shadow-md flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ff8e48]/60 disabled:opacity-50 sm:ml-3",
                    onClick: handleSave,
                    disabled: __props.loading
                  }, [
                    (__props.loading)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 mr-2 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    (__props.mode === 'add')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Add"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, "Update"))
                  ], 8, _hoisted_47),
                  _createElementVNode("button", {
                    type: "button",
                    class: "w-full sm:w-auto px-4 py-2 rounded-xl font-semibold text-sm bg-slate-50 dark:bg-slate-700/30 text-slate-700 dark:text-slate-200 border border-slate-200/60 dark:border-slate-700/60 hover:bg-slate-100 dark:hover:bg-slate-700/50 disabled:opacity-50",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close'))),
                    disabled: __props.loading
                  }, " Cancel ", 8, _hoisted_50)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})